export default "__VITE_ASSET__B_vQad6___"